import React from "react";
import {FormattedMessage} from "react-intl";

const ResultDetailTTT = ({time}) => {
    if (!time) {
        return null
    }
    return <div className="module__title"><FormattedMessage id="details.teamTimeTrial"/>{`: ${time}`}</div>
};

export default ResultDetailTTT
